<template lang="html">
  <section class="country_model_log">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="country_model_log_filters"  class="mt-2 ml-4 mr-4" visible>
            <b-card>
              <h4 class="card-text">Filters</h4>
              <b-row>
                <div class="col-lg-2 pt-2">Id:</div><input type="number" class="col-lg-3" v-model="filter.id" placeholder="Id" /><div class="col-lg-2"/>
                <div class="col-lg-2 pt-2">Insert user:</div><input type="text" class="col-lg-3" v-model="filter.insertUser" placeholder="Insert user" />
              </b-row>
              <br>
              <b-row>
                <div class="col-lg-2 pt-2">Insert date from:</div>
                <b-row class="col-lg-3 row-datepicker">
                  <datepicker class="col-lg-11 p-0" format="dd/MM/yy" placeholder="Insert date from" v-model="filter.insertDateFrom"/>
                  <b-button class="p-1 m-auto col-lg-1 ml-3" size="sm" variant="primary" v-b-tooltip.hover title="Empty insert date from" @click="filter.insertDateFrom=null">
                    <i class="mdi mdi-close"/>
                  </b-button>
                </b-row>
                <div class="col-lg-2"/>
                <div class="col-lg-2 pt-2">Insert date to:</div>
                <b-row class="col-lg-3 row-datepicker">
                  <datepicker class="col-lg-11 p-0" format="dd/MM/yy" placeholder="Insert date to" v-model="filter.insertDateTo"/>
                  <b-button class="p-1 m-auto col-lg-1 ml-3" size="sm" variant="primary" v-b-tooltip.hover title="Empty insert date to" @click="filter.insertDateTo=null">
                    <i class="mdi mdi-close"/>
                  </b-button>
                </b-row>
              </b-row>
              <br>
              <b-row>
                <b-col class="col-lg-2 pt-2">Market:</b-col>
                <b-select class="col-lg-3" v-model="filter.country">
                  <option :value="country" v-if="getCurUser" v-for="country in getCurUser.countries">{{country.description }}</option>
                </b-select>
                <div class="col-lg-2"/>
                <b-col class="col-lg-2 pt-2">Model:</b-col>
                <b-select class="col-lg-3" v-model="filter.model" v-if="filter.country && filter.country.modelGroupItemList">
                  <template v-for="models in filter.country.modelGroupItemList">
                    <optgroup :label="models.label"><option v-for="model in models.items" :key="model.value" :value="model">{{ model.label }}</option></optgroup>
                  </template>
                </b-select>
              </b-row>
              <br>
              <b-row>
                <div class="col-lg-2 pt-2">Flag:</div>
                <b-select class="col-lg-3" v-model="filter.field">
                  <option :value="null">All</option>
                  <option value="CCFE">CCFE</option>
                  <option value="MXE">MXE</option>
                </b-select>
                <div class="col-lg-2"/>
                <div class="col-lg-2 pt-2">Action:</div>
                <b-select class="col-lg-3" v-model="filter.setValue">
                  <option :value="null">All</option>
                  <option :value="true">Enabled</option>
                  <option :value="false">Disabled</option>
                </b-select>
              </b-row>
              <br>
              <b-button variant="primary" v-b-toggle.country_model_log_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Country Model Log</h4>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination align="fill" limit="6" v-model="currentPage" :total-rows="totalRowsResult" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" ellipsisText="..." 
                  aria-controls="" class="col-lg-10"></b-pagination>
              </div>
            </div>
            <div class="col-lg-1">
              <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                <b-form-select-option value="5">5</b-form-select-option>
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="20">20</b-form-select-option>
                <b-form-select-option value="50">50</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </div>
            <div class="col-lg-4">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="search"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.country_model_log_filters><i class="mdi mdi-filter"></i></b-button>
              </span>
            </div>
            <b-table ref="country_model_log_tab" id="table" striped hover responsive :items="items" :fields="fields" :per-page="perPage" :current-page="1" 
              primary-key="id" no-local-sorting no-provider-paging sort-icon-left>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import Datepicker from 'vuejs-datepicker';
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'country_model_log',
  components: {
    Datepicker
  },
  methods: {
    search() {
      this.setLastSearch(this.search)
      this.setSpinnerStatus(true);
      if(this.filter.insertDateFrom) {
        this.filter.insertDateFrom = new Date(this.filter.insertDateFrom);
        this.filter.insertDateFrom.setHours(0, 0, 0, 0);
      }
      if(this.filter.insertDateTo) {
        this.filter.insertDateTo = new Date(this.filter.insertDateTo);
        this.filter.insertDateTo.setHours(23, 59, 59, 999);
      }
      var params = { page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc },
        data = { ...this.filter, countryId: this.filter.country.id, modelcode: this.filter.model.value }; 
      this.axios.post('/ccb/auth/fe/countryModelLog', data, { params: params, ...this.authHeader })
        .then((response) => {
          this.items = response.data.content;
          this.totalRowsResult = response.data.totalElements;
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(() => this.setSpinnerStatus(false));
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      return new Date(value).toLocaleString('it-IT');
    },
    formatCountry(value) {
      if (!value) {
        return '';
      }
      return this.filter.country.description;
    },
    formatModel(value) {
      if (!value) {
        return '';
      }
      return this.filter.model.label;
    },
    formatValue(value) {
      if (!value) {
        return '';
      }
      return value == "true" ? 'Enabled' : 'Disabled';
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  data() {
    return {
      items: [],
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: false,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'insertUser',
          label: 'Insert User',
          sortable: true
        },
        {
          key: 'insertDate',
          label: 'Insert Date',
          formatter: this.formatDate,
          sortable: true
        },
        {
          key: 'countryId',
          label: 'Market',
          formatter: this.formatCountry,
          sortable: true
        },
        {
          key: 'modelcode',
          label: 'Model',
          formatter: this.formatModel,
          sortable: true
        },
        {
          key: 'field',
          label: 'Flag',
          sortable: true
        },
        {
          key: 'setValue',
          label: 'Action',
          formatter: this.formatValue,
          sortable: true
        }
      ],
      filter: { 
        insertUser: null,
        insertDateFrom: null,
        insertDateTo: null,
        country: null,
        countryId: null,
        model: null,
        modelcode: null,
        field: null,
        setValue: null
      },
    }
  },
  computed: {
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ])
  },
  watch: {
    currentPage() {
      this.search();
    },
    perPage() {
      this.search();
    },
    sortBy() {
      this.search();
    },
    sortDesc() {
      this.search();
    },
    'filter.country'(newVal, oldVal) {
      if(newVal === oldVal) return;
      if (newVal) {
        this.filter.model = newVal.modelGroupItemList[0].items[0];
      } else {
        this.filter.model = null;
      }
    }
  },
  mounted() {
    window.scoper = this;
    this.setCurApp('ccadm');
    this.filter.country = this.getCurUser.countries[0];
    if (this.filter.country) {
      this.filter.model = this.filter.country.modelGroupItemList[0].items[0];
    }
    this.search();
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.row-datepicker {
  border: 1px solid lightgray;
  padding: 0;
  margin: 0;
}
.mdi-close {
  color: white;
  display: block;
  cursor: pointer;
}
.ml-3 {
  margin-left: -3px !important;
}
input {
  padding-left: 10px;
}
</style>
